import { type AvailableTools, AvailableToolsSchema } from '@sbc/domain-models/agents';
import { useQuery } from '@tanstack/react-query';

import { apiGet } from './client';

export function useAvailableTools() {
  return useQuery<AvailableTools>({
    queryKey: ['admin', 'available-tools'],
    queryFn: () => apiGet('/api/admin/agents/available-tools', AvailableToolsSchema),
  });
}
